import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "col-md-6 mx-auto" }
const _hoisted_2 = { class: "dl-horizontal" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("dt", null, "ID", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("dt", null, "Name", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("dt", null, "Type", -1)
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("dt", null, "Match", -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("dt", null, "Cost", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("dt", null, "Prizes", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("dt", null, "Game", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("dt", null, "Round", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("dt", null, "Time Unit", -1)
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("dt", null, "Time Duration", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("dt", null, "Prepare Seconds", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("dt", null, "Open Seconds", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("dt", null, "Close Seconds", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("dt", null, "Ranking Seconds", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("dt", null, "Status", -1)
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("dt", null, "Publish Time", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("dt", null, "Next Start Time", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("dt", null, "Next Ranking Time", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("dt", null, "Unpublish Time", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("dt", null, "Thumbnail", -1)
const _hoisted_27 = { class: "card-footer bg-white border border-light" }
const _hoisted_28 = { class: "col text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AppImageHolder = _resolveComponent("AppImageHolder")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_app_card = _resolveComponent("app-card")!

  return (_openBlock(), _createBlock(_component_app_card, {
    class: "col-lg-8 mx-auto",
    label: "Duplicate Detail "
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("dl", _hoisted_2, [
          _createElementVNode("tr", null, [
            _hoisted_3,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.id), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_4,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.name), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_5,
            _createElementVNode("dd", {
              innerHTML: _ctx.renderOption(_ctx.DuplicateItemOptions.Type, _ctx.model.type)
            }, null, 8, _hoisted_6)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_7,
            (_ctx.model.matchId)
              ? (_openBlock(), _createElementBlock("dd", _hoisted_8, [
                  _createVNode(_component_router_link, {
                    to: { name: _ctx.ROUTE_NAME_GAME.MATCH.DETAIL, params: { id: _ctx.model.matchId } }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.model.matchName), 1)
                    ]),
                    _: 1
                  }, 8, ["to"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_9,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.cost), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_10,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.prizes), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_11,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.game), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_12,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.round), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_13,
            _createElementVNode("dd", {
              innerHTML: _ctx.renderTimeUnit(_ctx.model.timeUnit)
            }, null, 8, _hoisted_14)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_15,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.timeDuration), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_16,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.prepareSeconds), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_17,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.openSeconds), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_18,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.closeSeconds), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_19,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.rankingSeconds), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_20,
            _createElementVNode("dd", {
              innerHTML: _ctx.renderOption(_ctx.DuplicateItemOptions.Status, _ctx.model.status)
            }, null, 8, _hoisted_21)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_22,
            _createElementVNode("dd", null, _toDisplayString(_ctx.formatDate(_ctx.model.publishTime)), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_23,
            _createElementVNode("dd", null, _toDisplayString(_ctx.formatDate(_ctx.model.nextStartTime)), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_24,
            _createElementVNode("dd", null, _toDisplayString(_ctx.formatDate(_ctx.model.nextRankingTime)), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_25,
            _createElementVNode("dd", null, _toDisplayString(_ctx.formatDate(_ctx.model.unpublishTime)), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_26,
            _createElementVNode("dd", null, [
              _createVNode(_component_AppImageHolder, {
                status: _ctx.model.thumbnailStatus,
                image: _ctx.model.thumbnail
              }, null, 8, ["status", "image"])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          _createVNode(_component_app_button, {
            name: "Edit",
            icon: "fa-edit",
            theme: "info",
            to: { name: _ctx.ROUTE_NAME_DUPLICATE.ITEM.EDIT, params: { id: _ctx.model.id } }
          }, null, 8, ["to"]),
          _createVNode(_component_app_button, {
            name: "Translate",
            icon: "fa-language",
            theme: "info",
            to: { name: _ctx.ROUTE_NAME_DUPLICATE.ITEM.TRANSLATE, params: { id: _ctx.model.id } }
          }, null, 8, ["to"]),
          (_ctx.model.canDelete)
            ? (_openBlock(), _createBlock(_component_app_button, {
                key: 0,
                name: "Delete",
                icon: "fa-trash-alt",
                theme: "danger",
                onClick: _withModifiers(_ctx.actions.remove, ["prevent"])
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }))
}